export default "__VITE_ASSET__Bboeh__J__"